
import { defineComponent } from "vue";
import Breadcrumb from "primevue/breadcrumb";
import Button from "primevue/button";
import Card from "primevue/card";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import FabButton from "@/components/UI/KnFabButton.vue";
import Message from "primevue/message";
import TabPanel from "primevue/tabpanel";
import TabView from "primevue/tabview";
import ThemeManagementDescriptor from "./ThemeManagementDescriptor.json";

export default defineComponent({
  name: "theme-management-examples",
  components: { Breadcrumb, Button, Card, Column, DataTable, FabButton, Message, TabPanel, TabView },
  props: { properties: Object },
  data() {
    return {
      examples: ThemeManagementDescriptor.examples,
    };
  },
  mounted() {
    this.updateStyle(this.properties);
  },
  updated() {
    this.updateStyle(this.properties);
  },
  methods: {
    updateStyle(properties) {
      for (let key in properties) {
        // @ts-ignore
        this.$refs.example.style.setProperty(key, properties[key]);
      }
    },
  },
});
